import React from "react";
import GovernmentSchemeFormPage from "../components/government-schemes/GovernmentSchemeFormPage";

const GovernmentSchemeCreate = () => <GovernmentSchemeFormPage mode="create" />;

export default GovernmentSchemeCreate;
